import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import {
  postOriginApiCrud,
  type PostOriginRequest,
  type PostOriginResponse,
} from "@/generated/fastapi";

export async function postOrigin(
  accessToken: string | null | undefined,
  request: PostOriginRequest,
): Promise<PostOriginResponse> {
  const response = await postOriginApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200 || !response.data) {
    throw new Error(`Failed to add origin (${response.status})`);
  }

  if (
    response.data.status !== "created" &&
    response.data.status !== "success" &&
    response.data.status !== "pending"
  ) {
    throw new Error(response.data.message || "Failed to add origin");
  }

  return response.data;
}
